module.exports = __webpack_public_path__ + "img/google-pay_black.3a4e768b.svg";